/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
} from '@angular/forms';

@Component({
    selector: 'ellf-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => TextInputComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class TextInputComponent implements ControlValueAccessor {
  @Input()
  controlType = 'text';

  @Input()
  placeholder = '';

  @Input()
  readOnly = false;

  @Input()
  longText = false;

  @Input()
  disabled = false;

  value = '';

  @Input()
  hasError = false;

  @Input()
  rows = 2;

  @Input()
  maxlength: number | null = null;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  propagateChange = (value: string) => {};
  onTouched = () => {};
  validateFn: any = () => {};

  validate(control: UntypedFormControl) {
    const res = this.validateFn(control);
    if (res) this.hasError = true;
    return res;
  }

  constructor(private cd: ChangeDetectorRef) {}

  onChange() {
    this.propagateChange(this.value);
    this.onTouched();
  }

  writeValue(obj: string) {
    this.value = obj;
    this.cd.detectChanges();
  }

  registerOnChange(fn: (value: string) => void) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.cd.detectChanges();
  }

  onBlur() {
    this.blur.emit();
  }
}
